import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import en from '@/i18n/en';
import es from '@/i18n/es';

const translations = { en, es };
const TranslationContext = createContext(null);

function detectLanguage() {
  const stored = localStorage.getItem('vrs_language');
  if (stored && (stored === 'en' || stored === 'es')) return stored;
  const nav = navigator.language || navigator.userLanguage || 'en';
  return nav.startsWith('es') ? 'es' : 'en';
}

export function TranslationProvider({ children }) {
  const [language, setLanguageState] = useState(detectLanguage);

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    localStorage.setItem('vrs_language', lang);
  }, []);

  const t = useCallback((key, params) => {
    let text = translations[language]?.[key] || translations.en?.[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
      });
    }
    return text;
  }, [language]);

  return (
    <TranslationContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
}
